export default "__VITE_ASSET__CyOzi5YA__"